export default "__VITE_ASSET__CQQjmIQY__"